import React, { useState, useEffect, useRef } from "react"
import api from "API/Api"
import { Row, Col, Spinner, UncontrolledAlert } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"
import { AuthUser } from "API/UserAccess"

const AddUser = () => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [roles, setRoles] = useState([])

  useEffect(() => {
    const getRoles = async () => {
      try {
        const resp = await api.get("role-by/" + (AuthUser?.role || 7))
        setRoles(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
      } catch (e) { console.error("Failed to load roles:", e) }
    }
    getRoles()
  }, [])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const payload = {
        ...values,
        addedBy: AuthUser?.uid || AuthUser?.id || 0
      }
      const response = await api.post("register", payload)
      if (response.data.success === true) {
        formRef.current.reset()
        setSubmitted(true)
        setTimeout(() => setSubmitted(false), 4000)
      }
    } catch (error) { console.error(error) }
    setLoading(false)
  }

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Add User</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}>
            <Link to="/users" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link>
          </Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm ref={formRef} className="form-horizontal mt-4" onValidSubmit={handleValidSubmit}>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField name="name" label="Full Name *" placeholder="Enter Full Name" type="text" required />
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField name="username" label="Username *" placeholder="Enter Username" type="text" required />
            </div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField name="email" label="Email *" placeholder="Enter Email" type="email" required />
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField type="select" name="role" label="Role *" helpMessage="Choose a role for this user" required>
                <option value="">Select Role</option>
                {roles.map((role, i) => (
                  <option key={i} value={String(role.id)}>{role.setting_name} ({role.access_level})</option>
                ))}
              </AvField>
            </div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField name="password" label="Password *" type="password" required placeholder="Enter Password"
                validate={{ minLength: { value: 6, errorMessage: "Minimum 6 characters" } }} />
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField name="confirm_password" label="Confirm Password *" type="password" required placeholder="Confirm Password"
                validate={{ match: { value: "password", errorMessage: "Passwords don't match" } }} />
            </div></Col>
          </Row>
          <div className="mb-3 row mt-4">
            <div className="col-6">
              {submitted && <UncontrolledAlert color="success"><strong>User Added Successfully!</strong></UncontrolledAlert>}
            </div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner size="sm" /><span style={{ paddingLeft: "10px" }}>Adding...</span></> : <span><i className="fas fa-user-plus"></i> Add User</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}

export default AddUser
